import { post, destroy } from '@/api/request';

function subscribe({ appId, packageId }) {
  return post(`/apps/${appId}/packages/${packageId}/subscribe`);
}

function cancelSubscription(appId) {
  return destroy(`/apps/${appId}/cancel_subscription`);
}

export default {
  subscribe,
  cancelSubscription,
};



// WEBPACK FOOTER //
// ./src/store/modules/appMembership/api.js